import { render, staticRenderFns } from "./importPeriodoVarios.vue?vue&type=template&id=4bc78039&scoped=true"
import script from "./importPeriodoVarios.vue?vue&type=script&lang=js"
export * from "./importPeriodoVarios.vue?vue&type=script&lang=js"
import style0 from "./importPeriodoVarios.vue?vue&type=style&index=0&id=4bc78039&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc78039",
  null
  
)

export default component.exports